import { render, staticRenderFns } from "./optins.vue?vue&type=template&id=48d87280&"
import script from "./optins.vue?vue&type=script&lang=js&"
export * from "./optins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports